import { create } from "zustand";

import { EDeviceType, getDeviceType } from "@utils/deviceDetect";
import { EBrowser, getBrowserDetails, getBrowserInfo } from "@utils/getBrowserInfo";

type TClientInfo = {
	currentBrowser: EBrowser;
	currentBrowserName: string;
	currentDeviceType: EDeviceType;
};

export type TAppInfoStore = {
	currentBrowser: EBrowser;
	currentBrowserName: string;
	currentDeviceType: EDeviceType;
	setClientInfo: (clientInfo: TClientInfo) => void;
};

const { browserName } = getBrowserDetails();

export const userAppInfoStore = create<TAppInfoStore>()((set) => ({
	currentBrowser: getBrowserInfo(),
	currentBrowserName: browserName,
	currentDeviceType: getDeviceType(),
	setClientInfo: (clientInfo) => set(clientInfo),
}));
